import { render, staticRenderFns } from "./SlotsFilters.vue?vue&type=template&id=deaa83e0&scoped=true&lang=pug"
import script from "./SlotsFilters.vue?vue&type=script&lang=js"
export * from "./SlotsFilters.vue?vue&type=script&lang=js"
import style0 from "./SlotsFilters.vue?vue&type=style&index=0&id=deaa83e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaa83e0",
  null
  
)

export default component.exports